import React from 'react'
import { Draggable } from 'react-beautiful-dnd'

import GripIcon from '../../icons/grip.svg?react'
import TrashIcon from '../../icons/ps_reporting_trash.svg?react'
import { PSComponent } from '../../models/PSComponent'

type Props = {
    metric: PSComponent
    index: number
    onDelete: (metric: PSComponent) => void
    onEdit: (metric: PSComponent) => void
    hasOneCard: boolean
}

export const ReportMetricsCard = ({ metric, index, onDelete, onEdit, hasOneCard }: Props) => {
    return (
        <Draggable draggableId={metric.id!} index={index} isDragDisabled={hasOneCard}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    className="reportMetricCard"
                    tabIndex={0}
                    onClick={() => onEdit(metric)}
                    onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault()
                            event.stopPropagation()
                            onEdit(metric)
                        }
                    }}
                >
                    <div className="label">
                        <div className="title">{metric.title}</div>
                        <div className="subtitle">{metric.memo}</div>
                    </div>
                    {!hasOneCard && (
                        <div className="icons">
                            <div
                                className="delete"
                                tabIndex={0}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onDelete(metric)
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        event.stopPropagation()
                                        onDelete(metric)
                                    }
                                }}
                            >
                                <TrashIcon />
                            </div>
                            <div
                                {...provided.dragHandleProps}
                                className="grip"
                                tabIndex={0}
                                onClick={(e) => e.stopPropagation()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        event.stopPropagation()
                                        event.preventDefault()
                                    }
                                }}
                            >
                                <GripIcon />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </Draggable>
    )
}
